﻿<template>
  <section>
    <div class="row collapse">
      <h3 class="small-9 columns header-with-icon">
        <span
          :class="'icon-large policy-type-name-' + data.Type.replace('_', '')"
          data-test="quickquote-conv-title-icon"
        />
        <span data-test="quickquote-conv-title-text" v-text="data.Name" />
      </h3>
      <div class="small-3 columns text-right align-self-middle">
        <a
          class="link-icon"
          style="text-decoration: none"
          data-test="validation-button-remove"
          @click="removeQuickQuote()"
        >
          <strong title="Slet" class="icon-trash" />
        </a>
      </div>
      <h3 class="small-1 columns header-with-icon">
        <strong v-if="data.StateEnum === 1" class="spinner spinner-button" />
      </h3>
    </div>

    <h3 v-text="content.Title" />
    <div>
      <label for="firstname">
        <strong v-text="content.FirstNameLabel" />
      </label>
      <Field
        id="firstName"
        v-model="firstName"
        :rules="{ required: true }"
        type="text"
        name="firstname"
        :label="content.FirstNameLabel"
        :placeholder="content.FirstNamePlaceholder"
        data-test="first-name-field"
        @input="changedInput"
      />
      <ValidationError name="firstname" :scope="scope" />
    </div>
    <div>
      <label for="lastname">
        <strong v-text="content.LastNameLabel" />
      </label>
      <Field
        id="lastname"
        v-model="lastName"
        :rules="{ required: true }"
        type="text"
        name="lastname"
        :label="content.LastNameLabel"
        :placeholder="content.LastNamePlaceholder"
        data-test="last-name-field"
        @input="changedInput"
      />
      <ValidationError name="lastname" :scope="scope" />
    </div>
    <div v-html="content.Description" />
    <div v-text="content.CprTitle" />
    <div class="row">
      <div class="small-12 medium-6 columns">
        <cpr-number-field
          v-model="cprNumber"
          :label="content.CprTitle"
          :required="true"
          :placeholder="content.CprPlaceholder"
          name="cprfield"
          :scope="scope"
          @input="changedInput"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { CprFollowup } from './types/CprFollowup';
import { QuickQuoteStatus } from './types/QuickQuoteStatus';
import CprNumberField from '@/components/UI/CprNumberField.vue';
import ValidationError from '@/components/UI/ValidationError.vue';
import { defineComponent, PropType } from 'vue';
import { FormContextKey } from 'vee-validate';
import { inject } from 'vue';

export default defineComponent({
  name: 'ValidationItem',
  components: {
    CprNumberField,
    ValidationError
  },
  setup() {
    return { form: inject(FormContextKey, undefined) };
  },
  props: {
    data: {
      type: Object as PropType<QuickQuoteStatus>,
      required: true
    },
    content: {
      type: Object as PropType<CprFollowup>,
      required: true
    },
    scope: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      cprNumber: this.data.Asset?.Cpr || '',
      firstName: this.data.Asset?.Firstname || '',
      lastName: this.data.Asset?.Lastname || ''
    };
  },
  watch: {
    cprNumber() {
      if (this.data.Asset !== null) {
        this.data.Asset.Cpr = this.cprNumber || '';
      }
    },
    firstName() {
      if (this.data.Asset !== null) {
        this.data.Asset.Firstname = this.firstName || '';
      }
    },
    lastName() {
      if (this.data.Asset !== null) {
        this.data.Asset.Lastname = this.lastName || '';
      }
    }
  },
  methods: {
    removeQuickQuote() {
      this.$emit('remove', this.data.PolicyCacheId);
    },
    changedInput() {}
  }
});
</script>
